<template>
  <DBox
    :id="'cmp-comments'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add')} ${$t('comment')}`"
    @addClick="addCommentClick"
  >
    <NTable
      id="comments-list dbox1"
      :config="tableConfig"
      :headers="headers"
      :items="comments"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('comment')">
            <span class="txtov" :title="item['comment']">
              {{ item["comment"] }}
            </span>
          </td>

          <td v-bind="tdcon('options')">
            <div class="dt-icon-container">
              <img
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
                @click="e => onCommentDelete(item)"
                alt="Delete comments"
                title="Delete comments"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig, createTableHeader } from "../../plugins/datatable";
export default {
  components: { DBox, NTable },
  props: {
    comments: {
      type: Array,
      default: () => []
    },
    status: {
      type: String,
      required: true
    },
    locationId: {
      type: String,
      required: true
    },
    section: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {};
  },
  computed: {
    tableConfig: function() {
      return createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        showHeader: false
      });
    },
    headers: function() {
      return [
        createTableHeader("comment"),
        createTableHeader("options", { text: false, mw: 30 })
      ];
    }
  },
  methods: {
    addCommentClick: function(event) {
      console.log(this.status);
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_comment",
          status: this.status,
          id: `${this.locationId}`,
          section: this.section
        }
      });
    },
    onCommentDelete: function(comment) {
      this.$emit("delete", {
        comment_id: comment.comment_id,
        status: this.status
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.comments-list {
}
</style>
